import MOLoader from 'common/components/atoms/MOLoader';
import StyledSplashScreen from 'common/components/atoms/StyledSplashScreen';
import { useMemo } from 'react';

interface ILoadingScreen {
  isLoading?: boolean
  size?: 'xs' | 's' | 'm' | 'l' | 'xl'
  children?: React.ReactNode
}

const LoadingScreen: React.FC<ILoadingScreen> = ({ isLoading = false, size = 'l', children }) => {
  return (
    <>
      <StyledSplashScreen isVisible={isLoading} className="loader">
        <MOLoader size={size} />
      </StyledSplashScreen>
      {children}
    </>
  )
}
export default LoadingScreen
